<template>
    <div v-if="dataLoaded">
    <!-- Row top buttons -->
    <div class="row q-mb-lg">
      <div class="col-4" style="justify-content: flex-start">
        <q-btn
          class="capitalize ctrl-button"
          color="grey-5"
          :label="`${$store.state.stringsStore.strings.action.toOverview}`"
          @click="$router.push('/etim/combination')"
          icon="keyboard_backspace"
        />
      </div>
      <div class="col-8">
        <q-btn
            ref="save"
            class="capitalize ctrl-button right q-mr-sm"
            :color="readOnly
                    ? 'grey-5'
                    : 'ctrl-turquoise'
            "
            :label="
                readOnly
                    ? getString('action.edit')
                    : getString('action.save')
            "
            @click="saveChanges"
            :icon-right="readOnly ? 'edit' : 'save'"
        />
        <q-btn v-if="data.id"
          class="q-mr-md capitalize ctrl-button right"
          icon-right="delete"
          :disable="readOnly"
          color="negative capitalize"
          :label="$store.state.stringsStore.strings.action.delete"
          align="right"
          @click="deleteEtimCombination()"
        />
      </div>
    </div>

    <div class="row">
      <!-- Left column -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">Details</p>

            <div class="card-block">
              <div class="row">
                <div class="col">
                  <!-- Description -->
                  <q-field>
                    <q-input
                      :disable="readOnly"
                      v-model="data.description"
                      :error="
                          $v.data.description.$dirty &&
                          !$v.data.description.required
                      "
                      :float-label="getString('description')"
                    />
                  </q-field>
                </div>
                <div class="col">
                <!-- Unit -->
                <q-field>
                  <q-input
                    v-model="data.unit"
                    :disable="readOnly"
                    :float-label="'Unit'"
                    class="q-ml-md"
                  />
                </q-field>
                </div>

              </div>
              <div class="row q-mt-md">
                <div class="col">
                  <div class="q-if-label q-if-label-above">
                    <div class="q-if-label-inner ellipsis">
                      Template
                    </div>
                  </div>
                  <q-editor
                    :disable="readOnly"
                    ref="template"
                    class="full-width q-mb-sm"
                    v-model="content"
                    min-height="4rem"
                    @keydown.native.enter.prevent
                    @keyup.native="saveRange('template')"
                    @click.native="saveRange('template')"
                    @input="editorUpdate('template')"
                    :toolbar="[]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">{{ getString(null, 'Note', 'Notitie') }}</p>

            <div class="card-block">
              <div class="row">
                <div class="col">
                    <q-field>
                      <q-search
                        type="text"
                        v-model="noteLabel"
                        :disable="disable"
                        clearable
                        @clear="removeNote"
                        :float-label="getString(null, 'Search for features by name or code', 'Eigenschappen zoeken op naam of code')"
                      >
                        <q-autocomplete
                          :max-results="25"
                          :min-characters="2"
                          @search="search"
                          @selected="selectNoteItem"
                        />
                      </q-search>
                    </q-field>
                </div>
              </div>
              <div class="row q-mt-sm">
                <div class="col">
                  <q-list link>
                    <div v-if="data.note">
                      <!-- <q-chip
                        :disable="readOnly"
                        @click.native="removeNote"
                        closable
                        @hide="removeNote"
                      >
                      {{ formatnoteName }}
                      </q-chip> -->
                    </div>
                  </q-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-sm-12 col-xs-12 q-pl-md">
        <div class="row q-mb-sm">
          <div class="full-width">
            <p class="card-title">{{ getString(null, 'Features', 'Eigenschappen') }}</p>

            <div class="card-block">
              <div class="row">
                <div class="col">
                  <!-- Features -->
                  <q-field
                    >
                    <q-search type="text" v-model="inputField"
                      :float-label="getString(null, 'Search for features by name or code', 'Eigenschappen zoeken op naam of code')"
                      :disable="readOnly">
                      <q-autocomplete :max-results="25" :min-characters="2" @search="search" @selected="selected"/>
                    </q-search>
                  </q-field>
                </div>
              </div>
              <div class="row q-mt-sm">
                <div class="col">
                  <q-list link>
                    <div v-if="data.features">
                      <variable-tag
                        v-for="(variable, i) in data.features"
                        :disable="readOnly"
                        :key="i"
                        :name="variable.label"
                        :className="variable.code"
                        :onlyReadable="true"
                        @click.native="chipClicked(variable)"
                      >
                      </variable-tag>
                    </div>
                  </q-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    </div>
</template>

<script>
import Vue from 'vue';
// Mixins
import saveChanges from '@/mixins/detailViews/saveChanges';
import { required } from 'vuelidate/lib/validators';

// Components
import VariableTag from '@/components/VariableTag.vue';

export default {
  mixins: [saveChanges],
  components: {
    VariableTag,
  },
  validations: {
    data: {
      description: {
        required,
      },
    },
  },

  data() {
    return {
      inputField: '',
      dataLoaded: false,
      disable: false,
      endpoint: 'etim/combination',
      responseData: {
        single: 'combination',
      },
      noteInputField: '',
      templateLoaded: false,
      readOnly: true,
      inputSelected: '',
      currentRange: {},
      selectedItems: [],
      content: '',
      data: {
        features: [],
      },
    };
  },

  methods: {
    deleteEtimCombination() {
      this.$q.dialog({
        title: '',
        message: this.getString(null, 'Are you sure you would like to delete the current etim combination?', 'Weet je zeker dat jij de huidige etimcombinatie wilt verwijderen?'),
        ok: this.getString('dialog.confirm.ok'),
        cancel: this.getString('dialog.confirm.cancel'),
      }).then(() => {
        this.axios.delete(`etim/combination/${this.$route.params.id}`).then(() => {
          const messageEn = 'Etim combination successfully removed';
          const messageNl = 'Etimcombinatie succesvol verwijderd';

          this.$q.notify({
            message: this.$store.state.stringsStore.language === 'en' ? messageEn : messageNl,
            timeout: 2000,
            type: 'positive',
            position: 'top-right',
          });
          this.$router.push('/etim/combination');
        });
      });
    },

    selected(item, keyboard) {
      // Prevent adding on keyboard arrow down
      if (keyboard) return;
      // Remove the code from the label
      item.label = item.label.replace(` - ${item.code}`, '');
      this.data.features.push(item);
    },

    selectNoteItem(item, keyboard) {
      if(keyboard) return;
      // Remove the code from the label
      this.data.note = item;
    },

    removeNote() {
      if (this.readOnly) return;
      this.data.note = null;
    },

    async search(terms, done) {
      try {
        // Request items based on terms given
        const results = await this.axios.get(`etim/feature?autocomplete=${terms.toLowerCase()}`);

        this.foundItems = results.data.features;

        // Map only the item names/labels... to the suggested array
        const suggested = results.data.features.map(feature => ({ id: feature.id, label: `${feature.label} - ${feature.code}`, code: feature.code })).filter(feature => !this.mappedFeatureIds.includes(feature.id));

        // Suggested items found, return suggestions.
        if (suggested.length) {
          // filter out previously selected items
          const filtered = suggested.filter((val) => {
            const labels = this.selectedItems.map(item => item.label);
            return !labels.includes(val.label);
          });

          // Callback comparator for suggestions to entered term
          const isNotEqual = a => a.label.toLowerCase() !== terms.toLowerCase();

          // If the entered term is not the same as any suggested, allow user to add the term
          if (this.allowAdd) {
            if (suggested.every(isNotEqual) && this.promptNewMessage !== '') {
              filtered.push({ label: `${this.promptNewMessage} - "${terms}"`, value: terms, new: true });
            }
          }

          done(filtered);
        }

      // Since an error is thrown when no items are found in autocomplete -> promt new suggestion here.
      } catch (error) {
        if (this.promptNewMessage !== '' && this.allowAdd) {
          done([{ label: `${this.promptNewMessage} - "${terms}"`, value: terms, new: true }]);
        } else {
          done([]);
        }
      }
    },

    customMapItems(item) {
      return {
        label: item.label,
        id: item.id,
        code: item.code,
      };
    },

    chipClicked(item) {
      this.addVariable(item);
    },

    saveRange(inputSelected) {
      this.inputSelected = inputSelected;
      const edit = this.$refs[this.inputSelected];
      this.currentRange[this.inputSelected] = edit.caret.range;
    },

    createVariableTag(item) {
      const VariableTagComponent = Vue.extend(VariableTag);
      const tag = new VariableTagComponent({ propsData: { name: item.label, className: item.code } });
      tag.$mount();
      return tag.$el.outerHTML;
    },

    /**
     *
     */
    clearUnusedFeatures() {
      this.data.features = this.data.features.filter(f => this.content.includes(f.code));
    },

    editorUpdate(field) {
      this.content = this.getFieldPlainText(field);
    },

    getFieldPlainText(field) {
      const toClear = 'br,span';
      this.$refs[field]
        .getContentEl()
        .querySelectorAll(toClear)
        .forEach((el) => {
          if (!el.textContent.trim()) {
            el.parentNode.removeChild(el);
          }
        });
      let text = this.$refs[field].getContentEl().innerHTML;
      const htmlEl = document.createElement('div');
      htmlEl.innerHTML = text.trim();
      this.data.features.forEach((item) => {
        const varComponent = htmlEl.getElementsByClassName(
          `variables__${item.label.toLowerCase().split(' ').join('-')}`,
        );
        if (varComponent.length) {
          text = text.replaceAll(varComponent[0].outerHTML, `%${item.code}%`);
        }
      });
      return text.trim().replace(/&nbsp;/g, ' ');
    },

    addVariable(item) {
      if (!this.inputSelected) return;
      const edit = this.$refs[this.inputSelected];
      edit.caret.restore(this.currentRange[this.inputSelected]);
      edit.runCmd('insertText', '%to__replace%');
      const data = edit
        .getContentEl()
        .innerHTML.replaceAll('%to__replace%', this.createVariableTag(item));
      const scrollTop = document.getElementsByTagName('main')[0].scrollTop;
      edit.runCmd('selectAll');
      edit.runCmd('delete');
      edit.runCmd('insertHTML', data);
      document.getElementsByTagName('main')[0].scrollTop = scrollTop;
      edit.focus();
      this.editorUpdate('template');
    },

    requestParams() {
      // First filter out features not used in the template
      this.editorUpdate('template');
      this.clearUnusedFeatures();
      return {
        description: this.data.description,
        template: this.getFieldPlainText('template'),
        unit: this.data.unit,
        features: this.data.features.map(f => f.id),
        note: this.data.note ? this.data.note.id : null,
      };
    },
  },

  computed: {
    mappedFeatureIds() {
      return this.data.features.map(f => f.id);
    },
    noteLabel: {
      get() {
        return this.data.note ? this.data.note.label : '';
      },
      set(value) {
        this.noteLabel = value;
      },
    },
    templateWithTags: {
      get() {
        let stringWithTags = this.data.template;
        this.data.features.forEach((tag) => {
          stringWithTags = stringWithTags.replaceAll(`%${tag.code}%`, this.createVariableTag(tag));
        });
        return stringWithTags;
      },
    },

    formatnoteName() {
      return this.data.note.label.replace(` - ${this.data.note.code}`, '');
    },
  },

  mounted() {
    if (this.$route.params.id) {
      this.axios.get(`etim/combination/${this.$route.params.id}`).then((res) => {
        this.data = res.data.combination;
        let content = this.data.template;

        this.data.features.forEach((feature) => {
          content = content.replaceAll(`%${feature.code}%`, this.createVariableTag(feature));
        });
        this.content = content;
        this.dataLoaded = true;
      });
    } else {
      this.readOnly = false;
      this.dataLoaded = true;
    }
  },

};
</script>
